export default angular.module('eventix.common.directives.ctrlC', [])
    .directive('ctrlC', function($compile, UIMessages) {
        /**
         * @ngdoc directive
         * @name eventix.common.directives:ctrlC
         * @restrict attribute
         * @description
         * Add a Copy button to an element to provide users an easy way to copy-paste text
         * @example
         * ```
         * <input type="text" disabled ng-model="vm.shopLink" ctrl-c>
         * ```
         */
        return {
            restrict: 'A',
            priority: 1000,
            link: function(scope, el, attr) {
                let copyAttr = /(input|select)/i.test(el[0].tagName) ? 'value' : 'innerText';

                if (attr.ctrlCIcon !== 'false') {
                    let icon = angular.element('<a uib-tooltip="Copy" ng-click="copyToClipboard()"><i class="fa fa-clone mouse-pointer"></i></a>');
                    let offsetRight = _.sum(_.map(el.css(['marginRight', 'borderRightWidth']), parseFloat));
                    let offsetTop = _.sum(_.map(el.css(['marginTop', 'borderTopWidth']), parseFloat));
                    icon.css({
                        position: 'absolute',
                        right: (offsetRight + 7) + 'px',
                        top: (offsetTop + 7) + 'px',
                        zIndex: 999
                    });
                    el.removeAttr('ctrl-c');
                    let newParent = angular.element('<div style="position: relative"></div>');
                    newParent.append($compile(icon)(scope));
                    newParent.insertBefore(el);
                    el.appendTo(newParent);
                } else {
                    el.on('click', copyToClipboard);
                    scope.$on('destroy', () => {
                        el.off('click', copyToClipboard);
                    });
                }

                scope.copyToClipboard = copyToClipboard;

                function copyToClipboard() {
                    // attibuted to http://stackoverflow.com/a/30810322/7305801
                    let text = attr.ctrlC;
                    if (!text || !text.length)
                        text = copyAttr === 'value' ? el.val() : el.text();
                    let textArea = document.createElement('textarea');

                    // Place in top-left corner of screen regardless of scroll position.
                    textArea.style.position = 'fixed';
                    textArea.style.top = 0;
                    textArea.style.left = 0;

                    // Ensure it has a small width and height. Setting to 1px / 1em
                    // doesn't work as this gives a negative w/h on some browsers.
                    textArea.style.width = '2em';
                    textArea.style.height = '2em';

                    // We don't need padding, reducing the size if it does flash render.
                    textArea.style.padding = 0;

                    // Clean up any borders.
                    textArea.style.border = 'none';
                    textArea.style.outline = 'none';
                    textArea.style.boxShadow = 'none';

                    // Avoid flash of white box if rendered for any reason.
                    textArea.style.background = 'transparent';
                    textArea.value = text;

                    document.body.appendChild(textArea);
                    textArea.select();

                    try {
                        var successful = document.execCommand('copy');
                        var msg = successful ? 'successful' : 'unsuccessful';
                        UIMessages.push('Copied!');
                    } catch (err) {
                        UIMessages.push('common.notice.error');
                    }

                    document.body.removeChild(textArea);
                }
            }
        };
    }).name;
